export enum LoadingState {
  Initial,
  Loading,
  Loaded,
}
